import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  TextField,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Chip,
  Popover,
  Typography,
  Paper,
  Badge,
  Tooltip,
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  Search as SearchIcon,
  FilterList as FilterIcon,
  Refresh as RefreshIcon,
  KeyboardArrowDown as CaretIcon,
  FileDownloadOutlined as DownloadIcon,
  Close,
  InsertDriveFileOutlined,
  Menu as MenuIcon,
} from "@mui/icons-material";
import SelectFilesMenu from "../SelectFilesMenu/SelectFilesMenu";
import {
  getSelectedAuditedFilesMenuData,
  REQUEST_STATUS,
  resetSelectedAuditedFiles,
  setSelectedFileIds,     // ADD
  removeSelectedFileId,
} from "../SelectFilesMenu/SelectFilesMenuSlice";
import { useDispatch, useSelector } from "react-redux";
import { getEpisodeIdentifiers, setSelectedColumnFiles } from "../EnhanceFilters/EnhanceFiltersSlice";
import {
  getCodeEnhanceWorkflowViewData,
  resetPayload,
  setPayload,
} from "../pages/EnhanceWorkflow/EnhanceWorkflowSlice";
import { Stack } from "react-bootstrap";
import {
  resetEnhancePlusPayload,
  updatedEnhancePlusPayload,
} from "../pages/EnhancePlusWorkflow/EnhancePlusWorkflowSlice";
import { debounce } from "lodash";
import CircularProgress from "@mui/material/CircularProgress";
import {
  getCombinedReviewData,
  resetCombinedPayload,
  setCombinedPayload,
} from "../pages/combinedReview/CombinedReviewSlice";
import { getMRNoptions } from "../EnhanceFilters/EnhanceFiltersSlice";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
const MODULES = [
  "Enhance Workflow",
  "Enhance Plus Workflow",
  "Combined Review",
];
const SELECTED_FILES_STORAGE_KEY = "selectedWorkflowFiles";
const VERSIONS = [
  "Version 6",
  "Version 8",
  "Version 10",
  "Version 11",
  "Version 12",
];

const TableToolbar = ({
  activeModule = "Enhance Workflow",
  onModuleChange,
  onSearch,
  showVersionInfo = "Version 10",
  icdCode = "ICD007.hcp",
  files = [],
  // selectedFileIds = [],
  onFilesApply,
  filesLoading = false,
  onVersionChange,
  version,
  setVersion,
  onFilterClick,
  // selectedFileNames,
  onRefresh,
  onDownload,
  downloadLoading = false,
  isUnassignedView,
  setIsUnassignedView,
  isRecalledView,
  setIsRecalledView,
  setSidebarSelected,
  hasActiveFilters,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filesAnchor, setFilesAnchor] = useState(null);
  const [versionAnchor, setVersionAnchor] = useState(null);
  const [auditedFilespage, setAuditedFilespage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [filesPopoverAnchor, setFilesPopoverAnchor] = useState(null);
  const isFirstRender = useRef(true);
  const SEARCH_TYPES = {
    EPISODE: "episode",
    MRN: "mrn",
  };
  const [searchType, setSearchType] = useState(SEARCH_TYPES.EPISODE);
  const mrnFilter = useSelector((state) => state.enhanceFilters.dropdowns.mrn);
  const episodeFilter = useSelector(
    (state) => state.enhanceFilters.dropdowns.episode,
  );
  const selectedFileIds = useSelector((state) =>state.selectedAuditedFiles.selectedFileIds)
  const activeFilter =
    searchType === SEARCH_TYPES.EPISODE ? episodeFilter : mrnFilter;
  const recommendationLoading = activeFilter.status === REQUEST_STATUS.LOADING;
  const recommendationList = activeFilter.data;
  // const [recommendationAnchor, setRecommendationAnchor] = useState(null);
  const dispatch = useDispatch();
  const { data, status, hasMore } = useSelector(
    (state) => state.selectedAuditedFiles.files,
  );
  const enhancePayload = useSelector((state) => state.codeEnhance.payload); 
  const combinedPayload = useSelector((state) => state.combinedReview.payload);
  const enhancePlusPayload = useSelector(
    (state) => state.enhancePlusWorkflow.payload,
  );
const selectedColumnFiles = useSelector(
  (state) => state.enhanceFilters.selectedColumnFiles
);
const fileNameCache = useSelector(
   (state) => state.selectedAuditedFiles.fileNameCache,
 );
  // const [recommendationAnchor, setRecommendationAnchor] = useState(null);
  const searchBoxRef = useRef(null);
  const [showRecommendations, setShowRecommendations] = useState(false);
  const handleSelect = (mod) => {
    setAnchorEl(null);
    onModuleChange?.(mod);
    // onFilesApply?.([]);
    onVersionChange?.("");
  };
  const handleLoadMore = () => {
    if (status === REQUEST_STATUS.LOADING || !hasMore) return;
    setAuditedFilespage((prev) => prev + 1);
  };
  // add near your other debounce refs
  const [filesQuery, setFilesQuery] = useState("");
  const debouncedFilesSearchRef = useRef(
    debounce((value) => {
      setAuditedFilespage(1);
      dispatch(
        getSelectedAuditedFilesMenuData({ pageNumber: 1, search: value }),
      );
    }, 400),
  );

  useEffect(() => {
    return () => debouncedFilesSearchRef.current.cancel();
  }, []);

  
  useEffect(() => {
  const handleBeforeUnload = () => {
    sessionStorage.removeItem(SELECTED_FILES_STORAGE_KEY);
  };

  window.addEventListener("beforeunload", handleBeforeUnload);

  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
}, []);
  const getStoredSelectedFiles = () => {
  try {
    return JSON.parse(
      sessionStorage.getItem(SELECTED_FILES_STORAGE_KEY) || "[]"
    );
  } catch {
    return [];
  }
};

const storedSelectedFiles = getStoredSelectedFiles();

const persistedSelectedFileIds = storedSelectedFiles.map(
  (file) => file.id
);

const effectiveSelectedFileIds = selectedFileIds;

  const handleFilesSearchChange = (value) => {
    setFilesQuery(value);
    debouncedFilesSearchRef.current(value);
  };
  const debouncedRecommendationRef = useRef(
    debounce((value, type) => {
      if (type === SEARCH_TYPES.MRN) {
        dispatch(
          getMRNoptions({ search: value, page_number: 1, page_size: 10 }),
        );
      } else {
        dispatch(
          getEpisodeIdentifiers({
            search: value,
            page_number: 1,
            page_size: 10,
          }),
        );
      }
    }, 400),
  );

  useEffect(() => {
    return () => debouncedRecommendationRef.current.cancel();
  }, []);

const handleRefresh = () => {
  // 1. Clear search
  setSearchText("");
  setFilesQuery("");
  setAuditedFilespage(1);
  setShowRecommendations(false);

  // Cancel pending debounce calls
  debouncedFilesSearchRef.current.cancel();
  debouncedRecommendationRef.current.cancel();

  // 2. Clear selected files from sessionStorage
  sessionStorage.removeItem(SELECTED_FILES_STORAGE_KEY);

  // 3. Clear selected files from Redux
  dispatch(setSelectedFileIds([]));

  // 4. Clear column-wise selected files
  dispatch(setSelectedColumnFiles([]));

  // 5. Reset all module payloads
  dispatch(resetPayload());
  dispatch(resetEnhancePlusPayload());
  dispatch(resetCombinedPayload());

  // 6. Reset parent state
  onFilesApply?.([]);
  onSearch?.("", searchType);
  onVersionChange?.("");

  // 7. Existing parent refresh
  onRefresh?.();
};

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (searchText !== "") {
  //       onSearch?.(searchText);
  //     } else {
  //       onSearch?.("");
  //     }
  //   }, 500);

  //   return () => clearTimeout(timer);
  // }, [searchText]);
  // useEffect(() => {
  //   dispatch(getSelectedAuditedFilesMenuData(auditedFilespage));
  // }, [dispatch, auditedFilespage]);
  useEffect(() => {
  setSearchText("");
  setFilesQuery("");
  setAuditedFilespage(1);

  const storedFiles = getStoredSelectedFiles();

  if (storedFiles.length > 0) {
    const storedIds = storedFiles.map((file) => file.id);

    dispatch(setSelectedFileIds(storedIds));
  }
}, [activeModule, dispatch]);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    dispatch(
      getSelectedAuditedFilesMenuData({
        pageNumber: auditedFilespage,
        search: filesQuery,
      }),
    );
  }, [dispatch, auditedFilespage]);

  const selectedFileNames = useMemo(() => {
  const filesById = new Map(
    files.map((file) => [
      String(file.id),
      file.fileName,
    ])
  );

  return effectiveSelectedFileIds
    .map((id) => {
      return (
        filesById.get(String(id)) ??
        fileNameCache?.[String(id)] ??
        storedSelectedFiles.find(
          (file) => String(file.id) === String(id)
        )?.fileName
      );
    })
    .filter(Boolean);
}, [
  files,
  effectiveSelectedFileIds,
  fileNameCache,
]);


const selectedColumnFileNames = useMemo(() => {
  return (selectedColumnFiles || [])
    .map((file) => file.file_name)
    .filter(Boolean);
}, [selectedColumnFiles]);


const displayFileNames = useMemo(() => {
  return [
    ...new Set([
      ...selectedFileNames,
      ...selectedColumnFileNames,
    ]),
  ];
}, [selectedFileNames, selectedColumnFileNames]);


 const syncedSelectedFiles = useMemo(() => {
  const map = new Map();

  // Files currently available from API
  files.forEach((file) => {
    if (
      effectiveSelectedFileIds.some(
        (id) => String(id) === String(file.id)
      )
    ) {
      map.set(String(file.id), {
        id: file.id,
        fileName: file.fileName,
      });
    }
  });

  // Files stored in sessionStorage
  storedSelectedFiles.forEach((file) => {
    if (
      effectiveSelectedFileIds.some(
        (id) => String(id) === String(file.id)
      )
    ) {
      map.set(String(file.id), {
        id: file.id,
        fileName: file.fileName,
      });
    }
  });

  // Column filter selections
  (selectedColumnFiles || []).forEach((file) => {
    map.set(String(file.header_id), {
      id: file.header_id,
      fileName: file.file_name,
    });
  });

  return Array.from(map.values());
}, [
  files,
  effectiveSelectedFileIds,
  selectedColumnFiles,
]);

   const handleFilesApply = (ids) => {
  dispatch(setSelectedFileIds(ids));

  const selectedFiles = files.filter((file) =>
    ids.includes(file.id)
  );

  const existingStoredFiles = getStoredSelectedFiles();

  const selectedFileObjects = ids.map((id) => {
    const currentFile = selectedFiles.find(
      (file) => String(file.id) === String(id)
    );

    const existingFile = existingStoredFiles.find(
      (file) => String(file.id) === String(id)
    );

    return {
      id,
      fileName:
        currentFile?.fileName ||
        existingFile?.fileName ||
        "",
    };
  });

  sessionStorage.setItem(
    SELECTED_FILES_STORAGE_KEY,
    JSON.stringify(
      selectedFileObjects.filter((file) => file.fileName)
    )
  );

  onFilesApply?.(ids);
};
  const handleRemoveFile = (fileId) => {
  const fileIdString = String(fileId);

  // -----------------------------------------
  // 1. Remove from Redux selected IDs
  // -----------------------------------------
  const updatedIds = selectedFileIds.filter(
    (id) => String(id) !== fileIdString
  );

  dispatch(setSelectedFileIds(updatedIds));

  // -----------------------------------------
  // 2. Remove from column-wise selection
  // -----------------------------------------
  const updatedColumnFiles = (selectedColumnFiles || []).filter(
    (file) => String(file.header_id) !== fileIdString
  );

  if (
    updatedColumnFiles.length !==
    (selectedColumnFiles || []).length
  ) {
    dispatch(setSelectedColumnFiles(updatedColumnFiles));
  }

  // -----------------------------------------
  // 3. REMOVE FROM SESSION STORAGE
  // -----------------------------------------
  const storedFiles = getStoredSelectedFiles();

  const updatedStoredFiles = storedFiles.filter(
    (file) => String(file.id) !== fileIdString
  );

  if (updatedStoredFiles.length > 0) {
    sessionStorage.setItem(
      SELECTED_FILES_STORAGE_KEY,
      JSON.stringify(updatedStoredFiles)
    );
  } else {
    sessionStorage.removeItem(
      SELECTED_FILES_STORAGE_KEY
    );
  }

  // -----------------------------------------
  // 4. Sync parent payload
  // -----------------------------------------
  onFilesApply?.(updatedIds);
};
  useEffect(() => {
    if (selectedFileIds.length === 0) {
      setFilesPopoverAnchor(null);
    }
  }, [selectedFileIds]);
  const handleOpenFilesMenu = (e) => {
    setFilesAnchor(e.currentTarget);
    setAuditedFilespage(1);
    setFilesQuery("");
    dispatch(getSelectedAuditedFilesMenuData({ pageNumber: 1, search: "" }));
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(e.target)) {
        setShowRecommendations(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // NEW — real, in-flow trigger for the WorkflowSidebar's mobile Drawer.
  // Dispatches a plain custom DOM event instead of a prop, since the sidebar
  // and toolbar are siblings composed by a parent page we don't control —
  // this keeps the two components decoupled while still letting the toolbar
  // own the actual clickable hamburger space (no more floating overlay).
  const handleOpenWorkflowSidebar = () => {
    window.dispatchEvent(new CustomEvent("open-workflow-sidebar"));
  };
  // console.log(activeModule)
  return (
    <Box
      sx={{
        minHeight: 48,
        height: { xs: "auto", md: 48 },
        px: { xs: 1, sm: 1.25 },
        py: { xs: 0.75, md: 0 },
        borderBottom: "1px solid #e0e0e0",
        bgcolor: "#fff",
        display: "flex",
        flexWrap: { xs: "wrap", md: "nowrap" },
        alignItems: "center",
        justifyContent: { xs: "center", md: "flex-start" },
        gap: { xs: 0.5, sm: 0.75 },
        rowGap: { xs: 1, md: 0.75 },
      }}
    >
      {/* NEW — hamburger for the WorkflowSidebar's mobile Drawer. Real flex
          item, only below "md", sits first so it never overlaps anything. */}
      <IconButton
        onClick={handleOpenWorkflowSidebar}
        size="small"
        sx={{
          visibility: {
            xs: "hidden",
            md: "hidden",
          },
          display: {
            xs: "flex",
            md: "none",
          },
          p: 0.75,
          mr: 0.25,
          flexShrink: 0,
          order: 0,
        }}
      >
        <MenuIcon fontSize="small" sx={{ color: "#42526E" }} />
      </IconButton>

      {/* Left cluster: back arrow, select files, module button */}
      {/* {(isUnassignedView || isRecalledView) && (
  <IconButton
    size="small"
    sx={{ p: 0.5 }}
    onClick={() => {
      setIsUnassignedView(false);
      setIsRecalledView(false)
      setSidebarSelected()
       if (activeModule === "Combined Review") {
      dispatch(getCombinedReviewData(combinedPayload));
    } else {
      dispatch(getCodeEnhanceWorkflowViewData(enhancePayload));
    }
    }}
  >
    <ArrowBackIcon fontSize="small" sx={{ color: "#42526E" }} />
  </IconButton>
)} */}
      {(activeModule === "Enhance Workflow" ||
        activeModule === "Enhance Plus Workflow" ||
        activeModule === "Combined Review") &&
        (isUnassignedView || isRecalledView) && (
          <IconButton
            size="small"
            sx={{ p: 0.5 }}
            onClick={() => {
              setIsUnassignedView(false);
              setIsRecalledView(false);
              setSidebarSelected("");

              if (activeModule === "Combined Review") {
                // setVersion?.("Version");
                // onVersionChange?.("Version");
                dispatch(
                  setCombinedPayload({
                    ...combinedPayload,
                    page_number: 1,
                    unassigned_page: false,
                    is_flagged: false,
                    recall: false,
                  }),
                );
              } else if (activeModule === "Enhance Plus Workflow") {
                // setVersion?.("Version");
                // onVersionChange?.("Version");
                dispatch(
                  updatedEnhancePlusPayload({
                    ...enhancePlusPayload,
                    page_number: 1,
                    unassigned_page: false,
                    is_flagged: false,
                    recall: false,
                  }),
                );
              } else {
                dispatch(
                  setPayload({
                    ...enhancePayload,
                    page_number: 1,
                    unassigned_page: false,
                    is_flagged: false,
                    recall: false,
                  }),
                );
              }
            }}
          >
            <ArrowBackIcon fontSize="small" sx={{ color: "#42526E" }} />
          </IconButton>
        )}
      <Box
        sx={{
          // ml: { md: "auto", xs: "auto", sm: 2 },
          ml: { xs: 0, sm: 2, md: 1.5 },
          display: "flex",
          flexWrap: { xs: "wrap", sm: "nowrap" },
          alignItems: "center",
          gap: 1,
          flexShrink: 0,
          //  width: { xs: "100%", sm: "auto" },
          justifyContent: { xs: "flex-end", sm: "flex-start" },
          minWidth: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #d5dae2",
            borderRadius: 1,
            height: 35,
            overflow: "hidden",
            flexShrink: 0,
            order: { xs: 3, sm: 0 },
          }}
        >
          <>
            <Button
              onClick={handleOpenFilesMenu}
              endIcon={<CaretIcon sx={{ fontSize: 16 }} />}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                fontSize: { xs: "12px", sm: "13px" },
                px: { xs: 1, sm: 1.25 },
                minWidth: 0,
                height: "100%",
                borderRadius: 0,
                color: "#334155",
                whiteSpace: "nowrap",
              }}
            >
              Select Files
            </Button>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: "#d5dae2" }}
            />
          </>
          <IconButton
            size="small"
            sx={{ p: 0.6, borderRadius: 0, height: "100%" }}
            onClick={onDownload}
            disabled={downloadLoading}
          >
            {downloadLoading ? (
              <CircularProgress size={16} sx={{ color: "#42526E" }} />
            ) : (
              <DownloadIcon sx={{ fontSize: 18, color: "#42526E" }} />
            )}
          </IconButton>
        </Box>

        {/* Only mount the popover when the toolbar actually owns the trigger */}
        <SelectFilesMenu
          anchorEl={filesAnchor}
          open={Boolean(filesAnchor)}
          onClose={() => setFilesAnchor(null)}
          files={files}
          selectedIds={selectedFileIds}
          // onApply={onFilesApply}
          onApply={handleFilesApply}
          loading={status === REQUEST_STATUS.LOADING}
          onLoadMore={handleLoadMore}
          hasMore={hasMore}
          searchValue={filesQuery}
          onSearchChange={handleFilesSearchChange}
        />

        <Button
          variant="contained"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          endIcon={<CaretIcon sx={{ fontSize: 16 }} />}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "11px",
            px: 1.5,
            minWidth: 0,
            minHeight: 35,
            boxShadow: "none",
            bgcolor: "#CBE6FF",
            color: "#004B71",
            border: "1px solid #35A1EA",
            ml: { xs: 0, sm: 2 },
            flexShrink: 0,
            whiteSpace: "nowrap",
            order: { xs: 1, sm: 0 },
          }}
        >
          {activeModule}
        </Button>
        {/* {hasActiveFilters && (
          <Chip
            icon={<FilterIcon sx={{ fontSize: 14 }} />}
            label="Filters Active"
            size="small"
            onClick={onFilterClick}
            sx={{
              ml: { xs: 0, sm: 1 },
              height: 28,
              fontSize: "12px",
              fontWeight: 600,
              bgcolor: "#E0F2FE",
              color: "#0369A1",
              border: "1px solid #7DD3FC",
              cursor: "pointer",
              order: { xs: 2, sm: 0 },
              flexShrink: 0,
              "& .MuiChip-icon": { color: "#0369A1" },
            }}
          />
        )} */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          {MODULES.map((mod) => (
            <MenuItem
              key={mod}
              selected={mod === activeModule}
              onClick={() => handleSelect(mod)}
            >
              {mod}
            </MenuItem>
          ))}
        </Menu>
      </Box>
      {/* Right cluster: ICD chip + Version dropdown (conditional) + search + filter + refresh */}
      <Box
        sx={{
          ml: { xs: 0, md: "auto" },
          display: "flex",
          flexWrap: { xs: "wrap", md: "nowrap" },
          alignItems: "center",
          gap: 1,
          width: { xs: "100%", md: "auto" },
        }}
      >
        {displayFileNames.length > 0 && (
  <>
    <Tooltip
  title={
   displayFileNames.length === 1
  ? displayFileNames[0]
  : `${displayFileNames.length} files selected`
  }
  arrow
>
  <Chip
    label={
      displayFileNames.length === 1
        ? displayFileNames[0]
        : `${displayFileNames.length} files selected`
    }
    size="small"
    onClick={(e) => setFilesPopoverAnchor(e.currentTarget)}
    sx={{
      height: 35,
      borderRadius: 1,
      bgcolor: "#E0E7FF",
      color: "#4338CA",
      fontWeight: 500,
      fontSize: "13px",
      cursor: "pointer",

      // Fixed width so long filenames don't push Refresh out
      width: 140,
      maxWidth: 140,
      minWidth: 0,
      flexShrink: 1,

      "& .MuiChip-label": {
        display: "block",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    }}
  />
</Tooltip>

            <Popover
              open={Boolean(filesPopoverAnchor)}
              anchorEl={filesPopoverAnchor}
              onClose={() => setFilesPopoverAnchor(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              PaperProps={{
                sx: {
                  mt: 0.75,
                  borderRadius: 2,
                  boxShadow: "0 8px 24px rgba(15,23,42,0.12)",
                  border: "1px solid #E6ECF3",
                  overflow: "hidden",
                },
              }}
            >
              <Box sx={{ width: { xs: "80vw", sm: 300 }, maxWidth: 320 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 2,
                    py: 1.25,
                    borderBottom: "1px solid #EEF2F7",
                    bgcolor: "#F8FAFC",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#475569",
                      letterSpacing: "0.03em",
                    }}
                  >
                    SELECTED FILES · {syncedSelectedFiles.length}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => setFilesPopoverAnchor(null)}
                    sx={{ p: 0.25 }}
                  >
                    <Close sx={{ fontSize: 16, color: "#94A3B8" }} />
                  </IconButton>
                </Box>

                <Stack sx={{ maxHeight: 260, overflowY: "auto", py: 0.5 }}>
                  
                    { syncedSelectedFiles.map((file) => (
                      <Box
                        key={file.id}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          px: 2,
                          py: 1,
                          "&:hover": { bgcolor: "#F8FAFC" },
                        }}
                      >
                        <InsertDriveFileOutlined
                          sx={{
                            fontSize: 16,
                            color: "#94A3B8",
                            flexShrink: 0,
                          }}
                        />
                        <Typography
                          sx={{
                            flex: 1,
                            fontSize: 13,
                            color: "#334155",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={file.fileName}
                        >
                          {file.fileName}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => handleRemoveFile(file.id)} // NEW
                          sx={{ p: 0.4, flexShrink: 0 }}
                        >
                          <Close sx={{ fontSize: 14, color: "#94A3B8" }} />
                        </IconButton>
                      </Box>
                    ))}

                  {selectedFileIds.length === 0 && (
                    <Box sx={{ px: 2, py: 2 }}>
                      <Typography
                        sx={{
                          fontSize: 13,
                          color: "#94A3B8",
                          textAlign: "center",
                        }}
                      >
                        No files selected
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </Box>
            </Popover>
          </>
        )}
        {showVersionInfo && (
          <>
            {/* <Chip
              label={icdCode}
              size="small"
              sx={{ height: 35, borderRadius: 1, bgcolor: "#E0E7FF", color: "#4338CA", fontWeight: 400, fontSize: "14px" }}
            /> */}
            <Button
              onClick={(e) => setVersionAnchor(e.currentTarget)}
              endIcon={<CaretIcon sx={{ fontSize: 16 }} />}
              sx={{
                textTransform: "none",
                fontWeight: 400,
                fontSize: "14px",
                px: 1.25,
                minWidth: 0,
                height: 35,
                border: "1px solid #d5dae2",
                borderRadius: 1,
                color: "#334155",
                flexShrink: 0,
                whiteSpace: "nowrap",
              }}
            >
              {version}
            </Button>
            <Menu
              anchorEl={versionAnchor}
              open={Boolean(versionAnchor)}
              onClose={() => setVersionAnchor(null)}
            >
              {VERSIONS.map((v) => (
                <MenuItem
                  key={v}
                  selected={v === version}
                  onClick={() => {
                    onVersionChange?.(v);
                    setVersionAnchor(null);
                  }}
                >
                  {v}
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
        <ToggleButtonGroup
          value={searchType}
          exclusive
          size="small"
          onChange={(e, newType) => {
            if (!newType) return; // prevent deselecting both
            setSearchType(newType);
            setSearchText("");
            setShowRecommendations(false);
            debouncedRecommendationRef.current.cancel();
            onSearch?.("", newType);
          }}
          sx={{
            height: 35,
            flexShrink: 0,
            "& .MuiToggleButton-root": {
              textTransform: "none",
              fontSize: "12px",
              fontWeight: 600,
              px: 1.25,
              color: "#64748B",
              border: "1px solid #E2E8F0",
              whiteSpace: "nowrap",
              "&.Mui-selected": {
                bgcolor: "#E0F2FE",
                color: "#0369A1",
                borderColor: "#7DD3FC",
              },
            },
          }}
        >
          <ToggleButton value={SEARCH_TYPES.EPISODE}>Episode ID</ToggleButton>
          <ToggleButton value={SEARCH_TYPES.MRN}>MRN</ToggleButton>
        </ToggleButtonGroup>
        <Box
          sx={{
            position: "relative",
            flex: { xs: "1 1 100%", sm: "1 1 220px" },
            minWidth: 0,
            maxWidth: { xs: "100%", sm: 300, md: 300 },
          }}
        >
          <Box
            ref={searchBoxRef}
            sx={{
    display: "flex",
    alignItems: "center",
    border: "1px solid #E2E8F0",
    borderRadius: 1,
    height: 35,
    bgcolor: "#F1F5F9",
    overflow: "hidden",
    width: "100%",
    minWidth: 0,
  }}
          >
            <SearchIcon sx={{ color: "#6B7280", fontSize: 18, ml: 1 }} />
            <TextField
              size="small"
              variant="standard"
              placeholder={
                searchType === SEARCH_TYPES.MRN
                  ? "Search by MRN"
                  : "Search for Episode Identifier"
              }
              // onChange={(e) => onSearch?.(e.target.value)}
              value={searchText}
              onFocus={() => {
                if (searchText.trim()) {
                  setShowRecommendations(true);
                }
              }}
              onChange={(e) => {
                const value = e.target.value;
                setSearchText(value);

                if (!value.trim()) {
                  setShowRecommendations(false);
                  debouncedRecommendationRef.current.cancel();
                  onSearch?.("", searchType);
                  return;
                }

                setShowRecommendations(true);
                debouncedRecommendationRef.current(value, searchType);
              }}
              InputProps={{ disableUnderline: true }}
             sx={{
  width: "100%",
  minWidth: 0,
  flex: 1,
  mx: 1,
  "& .MuiInputBase-input": {
    fontSize: "14px",
    py: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}}
            />
            {showRecommendations && (
              <Paper
                elevation={4}
                sx={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  width: searchBoxRef.current?.offsetWidth || 300,
                  maxHeight: 280,
                  overflowY: "auto",
                  mt: 0.5,
                  zIndex: 1300,
                  borderRadius: 1.5,
                  border: "1px solid #E6ECF3",
                }}
              >
                {/* Header row */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 2,
                    py: 1,
                    borderBottom: "1px solid #EEF2F7",
                    bgcolor: "#F8FAFC",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#64748B",
                      letterSpacing: "0.04em",
                    }}
                  >
                    {searchType === SEARCH_TYPES.MRN ? "MRN" : "EPISODE ID"}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#64748B",
                      letterSpacing: "0.04em",
                    }}
                  >
                    {recommendationLoading
                      ? ""
                      : `${recommendationList.length} RESULT${recommendationList.length === 1 ? "" : "S"}`}
                  </Typography>
                </Box>

                {/* Body */}
                {recommendationLoading ? (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", py: 2.5 }}
                  >
                    <CircularProgress size={20} />
                  </Box>
                ) : recommendationList.length ? (
                  recommendationList.map((item) => (
                    <Box
                      key={item}
                      onClick={() => {
                        setSearchText(item);
                        onSearch(item, searchType);
                        setShowRecommendations(false);
                      }}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 2,
                        py: 1,
                        cursor: "pointer",
                        "&:hover": { bgcolor: "#F1F5F9" },
                      }}
                    >
                      <InsertDriveFileOutlined
                        sx={{ fontSize: 15, color: "#94A3B8", flexShrink: 0 }}
                      />
                      <Typography
                        sx={{
                          fontSize: 13.5,
                          color: "#334155",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ px: 2, py: 2.5, textAlign: "center" }}>
                    <Typography sx={{ fontSize: 13, color: "#94A3B8" }}>
                      No matching episodes
                    </Typography>
                  </Box>
                )}
              </Paper>
            )}
            <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: "#e3e6ea" }}
            />
            <IconButton
              size="small"
              sx={{ p: 0.6, borderRadius: 0 }}
              onClick={onFilterClick}
            >
              <Badge
                color="primary"
                variant="dot"
                invisible={!hasActiveFilters}
                sx={{ "& .MuiBadge-dot": { top: 3, right: 3 } }}
              >
                <FilterIcon
                  sx={{
                    fontSize: 18,
                    color: hasActiveFilters ? "#1976d2" : "#6B7280",
                  }}
                />
              </Badge>
            </IconButton>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: "#e3e6ea" }}
            />
            <IconButton
              size="small"
              sx={{ p: 0.6, borderRadius: 0 }}
              onClick={handleRefresh}
            >
              <RefreshIcon sx={{ fontSize: 18, color: "#6B7280" }} />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TableToolbar;
